import { useEffect, useState } from "react";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(null);
  useEffect(() => {
    const onResize = () => {
      const nowIsMobile = window.innerWidth < 768;

      if (nowIsMobile !== isMobile) {
        setIsMobile(nowIsMobile);
      }
    };

    onResize();
    window.addEventListener("resize", onResize);

    return () => window.removeEventListener("resize", onResize);
  });
  return isMobile;
};

export default useIsMobile;
